import { app } from '../../../../../../app';
import { Controller } from './bulk-verification.controller';

app.component('companyUserDirectoriesManageGroupAccountsBulkVerification', {
    bindings: {
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./bulk-verification.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/bulk-verification/bulk-verification.component.js